<template>
  <Container
    :class="'container--tablet'"
  >
    <template #component>
      <v-col
        class="container__col"
      >
        <v-row>
          <v-col class="container__inner-col">
            <HomeDialer />
            <!-- <Contacts
              :supported="isSupportedContacts"
            /> -->
          </v-col>
          <router-view
            v-if="!callsSubRoute()"
            class="container__inner-col"
            name="ContactDetails"
          />
        </v-row>
      </v-col>
      <v-col
        v-if="!isSpecialCustomer"
        class="container__col"
        :style="( threeColumns() && !callsSubRoute()) ? 'max-width: 35%;' : ''"
      >
        <v-row>
          <v-col class="container__inner-col">
            <RecentCalls
              :supported="isSupportedCallHistory"
            />
          </v-col>
          <router-view
            v-if="callsSubRoute() && itemsLoaded"
            class="container__inner-col"
            name="CallDetails"
          />
        </v-row>
      </v-col>
    </template>
  </Container>
</template>

<script>
import { mapGetters } from 'vuex'
import { breakpoints } from '@/mixins'
import Container from '@/views/Layout/Container.vue'
import RecentCalls from '@/components/Home-Recent-Calls/RecentCalls.vue'
import HomeDialer from '@/autoDialer/components/HomeDialer.vue'
import { specialCustomerArray } from '../autoDialer/constants'

export default {
  name: 'Home',
  components: {
    Container,
    HomeDialer,
    RecentCalls,
  },
  mixins: [breakpoints],
  computed: {
    ...mapGetters('account', ['info']),
    ...mapGetters('callHistory', {
      callHistoryItems: 'items',
    }),
    ...mapGetters('contacts', {
      contactsItems: 'items',
    }),
    ...mapGetters('system', [
      'isSupportedCallHistory',
      'isSupportedContacts',
    ]),
    itemsLoaded() {
      return this.callHistoryItems && this.callHistoryItems.length > 0
      && this.contactsItems && this.contactsItems.length > 0
    },
    isSpecialCustomer() {
      return specialCustomerArray.some((id) => this.info?.number?.includes(id))
    },
  },
  methods: {
    threeColumns() {
      return this.$route.params.number
      && this.$_breakpoints_desktop
    },
    callsSubRoute() {
      return this.$route.matched.some((route) => route.name === 'CallDetails')
    },
  },
}
</script>
